let productOptions = document.querySelectorAll('.js-product-options');

productOptions = Array.from(productOptions);

productOptions.forEach((option) => {
    const handle = option.getAttribute('data-product-form');

    fetch('/products/' + handle + '.js')
    .then(function(response) {
      response.json().then(data => {
        let product = data;
        let variants = product.variants;

        function updateSelection() {

            console.log('updating selection');

            let selfinder = [];

            productOptions.forEach(function (option) {
              var productOptionsInner = option.querySelectorAll('.js-product-option input:checked');

              if (productOptionsInner) {
                selfinder.push(productOptionsInner[0].value);
              }

            });

            let sel = [];

            variants.forEach((variant, i) => {
              if(JSON.stringify(variant.options) === JSON.stringify(selfinder)) {
                console.log(variant);

                sel.push(variant);
              }
            });

            let selection = sel[0];

            let currentActive = document.querySelector('.option__image .image__wrapper.active');

            if (currentActive) {
              currentActive.classList.remove('active');
            }

            document.querySelector('.js-variant').textContent = selection.option1;

            // update desc
            let desc = metaData[selection.id].description;
            if(desc) {
              document.querySelector('.product__details .js-desc span').textContent = desc;
            }

            // update notes
            let notes = metaData[selection.id].notes;
            let notesList = document.querySelector('.product__details .js-notes ul');

            // update img
            let imageLit = metaData[selection.id].image_lit;
            if(imageLit) {
              document.querySelectorAll('.js-imgbase img').forEach((img) => {
                img.src = imageLit;
              });
            }

            // console.log(metaData[selection.id].image_lit);
            if(metaData[selection.id].image_gallery) {
              console.log(metaData[selection.id].image_gallery);
            }

            if(notesList) {
              notesList.textContent = '';
            }

            if(notes && notesList) {
              notes.forEach((note) => {
                var li = document.createElement('li');
                li.innerText = note;
                notesList.appendChild(li);
              });
            }

            // update price
            let price = selection.price;
            document.querySelector('.js-price').innerHTML = '$' + (price/100);

            // update qty-input
            document.querySelector('.js-qty').value = 1;

            // update inventory-qty
            let selector = option.querySelector('.js-product-option input');
            let inventoryQty = selector.dataset.inventoryQty;

            // update max
            if (inventoryQty && inventoryQty > 0) {
              document.querySelector('.js-qty').max = inventoryQty;
            } else if (inventoryQty == 0) {
              document.querySelector('.js-qty').max = 1;
            } else {
              document.querySelector('.js-qty').removeAttribute('max');
            }

            // update cart button
            let addButton = document.querySelector('.js-add-to-cart');
            addButton.setAttribute('data-id', selection.id);


            // update availability
            let isAvailable = selection.available;

            if(isAvailable) {
              console.log('available');
              document.querySelector('.js-add-to-cart').disabled = false;
              document.querySelector('.js-cta-label').innerHTML = 'Add to bag -';
              // document.querySelector('.js-price').innerHTML = '$' + (price/100);
            } else {
              console.log('not available');
              document.querySelector('.js-add-to-cart').disabled = true;
              document.querySelector('.js-cta-label').innerHTML = 'Sold Out';
              document.querySelector('.js-price').innerHTML = '';
              document.querySelector('.js-qty').value = 0;
              document.querySelector('.js-qty').max = 0;
            }


            // update url
            if (selection) {
              var newUrl = window.location.href.split('?')[0] + '?variant=' + selection.id;
              history.pushState({}, null, newUrl);
              // window.location = newUrl
            }
        }

        // updateSelection();

        let productOption =  option.querySelector('.js-product-option');

        if (productOption) {
          productOption.addEventListener('change', (event) => {
            console.log('changed product option');
            updateSelection();
          });
        }
      });

    })
    .catch(function(error) {
      console.log(error);
    });
  });
